/** Main column uses background only (no inset card). */
export function isFlatContentShellPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, "") || "/";

  if (normalized === "/campaigns") {
    return true;
  }

  if (/^\/donors\/[^/]+$/.test(normalized)) {
    return true;
  }

  if (
    normalized === "/settings/integrations" ||
    normalized.startsWith("/settings/integrations/")
  ) {
    return true;
  }

  if (normalized === "/chat" || normalized.startsWith("/chat/")) {
    return true;
  }

  return [
    "/settings/brand",
    "/settings/identity",
    "/settings/installation",
  ].includes(normalized);
}

/** Flat shell pages that manage their own scroll (e.g. chat transcript). */
export function isFullHeightFlatShellPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === "/chat" || normalized.startsWith("/chat/");
}
